import React from "react";
import "./styles.scss";

const Tooltip = ({ content, position = "right" }) => {
  return (
    <div className="info-tooltip">
      <span className="info-icon">?</span>
      <span className={`tooltip-text ${position}`}>
        <div className="tooltip-content">{content}</div>
      </span>
    </div>
  );
};

export default Tooltip;
